import Icon from '../components/Icon.vue'

Icon.register({
  restroom: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 128C163.3 128 192 99.3 192 64S163.3 0 128 0 64 28.7 64 64 92.7 128 128 128zM512 128C547.3 128 576 99.3 576 64S547.3 0 512 0 448 28.7 448 64 476.7 128 512 128zM639.3 354.5L593.7 168.7C590.4 155.2 578.2 145.7 563.9 144.5 548.9 154.2 531.1 160 511.9 160 492.7 160 474.9 154.2 459.9 144.5 445.6 145.7 433.4 155.2 430.1 168.7L384.5 354.5C381 369.6 393 384 409.2 384H464V488C464 501.3 474.7 512 488 512H536C549.3 512 560 501.3 560 488V384H614.8C631 384 643 369.6 639.3 354.5zM336 0H304C295.2 0 288 7.2 288 16V496C288 504.8 295.2 512 304 512H336C344.8 512 352 504.8 352 496V16C352 7.2 344.8 0 336 0zM180.1 144.4C165.1 154.2 147.2 160 128 160 108.8 160 90.9 154.2 75.9 144.4 51.3 146.5 32 166.9 32 192V328C32 341.3 42.7 352 56 352H64V488C64 501.3 74.7 512 88 512H168C181.3 512 192 501.3 192 488V352H200C213.3 352 224 341.3 224 328V192C224 166.9 204.7 146.5 180.1 144.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/restroom.js
// module id = jQ9Y
// module chunks = 144